export const GET_POSTS_SEARCH = 'news/GET_POSTS_SEARCH';
export const CLEAR_POSTS_SEARCH = 'news/CLEAR_POSTS_SEARCH';



// WEBPACK FOOTER //
// ./src/redux/PostsSearch/constants.js